import { createContext, useContext, type ReactNode } from "react";

const ShellHeaderActionsContext = createContext<ReactNode>(null);

/** Supplied by the app shell: its top-bar controls (feature slots such as
 *  notifications, and the language switcher). */
export const ShellHeaderActionsProvider = ShellHeaderActionsContext.Provider;

/**
 * The shell's header controls, for a screen that hides the top bar
 * (`FeatureNavNode.hideTopBar`) and draws its own header -- so a feature
 * package can place them without importing the app shell.
 */
export function ShellHeaderActions() {
  return <>{useContext(ShellHeaderActionsContext)}</>;
}
